<template>
    <div>
        <div class="tabsFather">
            <div v-for="(item,index) in tabsData" :class="[tabsIndex == index ? 'tabsActive' : '','tabsClass']"  @click="tabsClick(index)">{{ item.title }}</div>
        </div>
        <div class="line999"></div>
        <template v-if="tabsIndex == '3'">
            <div class="commonFather">
                <div class="commonList" v-for="(item,index) in tabsData" :key="index"  @click="tabsClick(index)">
                    <div class="commonListLeft">{{ item.title }}</div>
                    <div class="commonListRight">{{ item.date }}</div>
                </div>
            </div>
        
            <div class="line999"></div>
            <div class="mob-line"></div>
            <!-- <van-pagination v-model="currentPage" :total-items="1" :items-per-page="5" /> -->
            <div class="pageClass">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="1">
                </el-pagination>
            </div>
        </template>
        <template v-if="tabsIndex == '0'">
            <div class="tabs1Title">公司简介</div>
            <div class="tabs1">
                <p> 集团自成立以来业态规模不断扩展，为绿色正能量在世界各地范围传播发挥了积极作用。分别专注于工业储能（含超级电容器）、汽车太阳能和绿色建筑的BIPV，新能源汽车及充电基础设施的研发、生产和运营以及新能源汽车的分时租赁、销售及相关增值服务，业务范围覆盖亚欧美三大目标市场<br>&nbsp;</p>
                <p>　　在充电基础设施领域， 集团拥有三方面优势：一是海外市场运营经验成熟，在欧美多地成功建设充电站并安全运营多年，广受外国友人认可；二是能够提供定制化的充电基础设施解决方案，备有多种商业模式可选，能够有效满足不同公共场所的特殊需求；三是充电桩产品水平世界领先，自主研发的充电桩产品具有智能性强，安全性高等特点，通过最严苛的美国UL、欧盟CE、中国国标等认证，兼容性符合国际，欧美SAE Combo等快速充电标准，能够与国内外所有主流新能源汽车完成充电协议对标。<br> 　　在储能领域，集团以比肩国际巨头为目标，围绕工业电容器、超级电容和储能系统打造核心产品线，销售网络遍及全国和欧洲，产品广泛应用于新能源领域。<br> 　　在光伏领域， 集团拥有全球一流的太阳能系统、光伏建筑一体化系统和汽车太阳能组件的研发和制造技术，是全球三家汽车曲面太阳能组件制造企业之一，也是两家获得欧盟绿色认证的企业之一。<br><br>﻿<br>　　2016年， 旗下全资子公司 新能源汽车销售公司成立，利用互联网、信息化、智能化及运营服务理念，将“小易充电”，“小易租车”两大核心业务完美结合，形成了从充电基础设施研发运营到新能源汽车销售再到新能源汽车分时租赁及后期多种增值服务为一体的新能源产业链。</p>
            </div>
        </template>
        <template v-if="tabsIndex == '1'">
            <div class="tabs1Title">大事记</div>
            <div class="tabs1">
                <div v-for="(item,index) in listData" :key="index" :item="item" style="display: flex;">
                    <h2 class="h2Class">{{item.dataYear}}</h2>
                    <div style="width: 600px;">
                        <ul class="ulClass list-paddingleft-2" v-for="(itemF,indexF) in item.dataDetails" :key="indexF">
                            <li><p><span class="monClass" style="">{{itemF.dataMonth}}</span></p></li>
                            <li><p class="detailClass" v-for="(itemS,indexS) in itemF.dataTipsData" :key="indexS">{{ itemS.dataTips }}</p></li>
                        </ul>
                    </div>
                    
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "mobIntroduce",
        data(){
            return{
                tabsData:[
                    {title:"公司简介",index:'2-1',date:"2016-07-14"},
                    {title:"大事记",index:'2-2',date:"2017-01-01"},
                ],
                currentPage:"1",
                tabsIndex:"3",
                listData:[
                    {
                        dataYear:'2021',
                        dataDetails:[
                            { 
                                dataMonth:'11月',
                                dataTipsData:[
                                    {dataTips:"11月15日，由 集团自主投资、设计、兴建并投入运营，全球最大、最先进、功能最完善的光伏超级充电站在上海松江落成"}
                                ]
                            },                          
                            { 
                                dataMonth:'9月',
                                dataTipsData:[
                                    {dataTips:"9月24日 ， 集团宣布与奇瑞新能源强强联手，双方签署战略合作协议，努力实现“互补共赢、携手并进、共创辉煌明天”的宏伟目标。"},
                                    {dataTips:"9月15日  集团受邀出席“大众创业，万众创新”活动周"},
                                ]
                            },
                            { 
                                dataMonth:'7月',
                                dataTipsData:[
                                    {dataTips:"7月4日，国务院副总理马凯携北京市相关领导视察新能源基础设施时来到华贸充电站，并鼓励公司继续保持良好的态势，引领新能源行业发展。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'6月',
                                dataTipsData:[
                                    {dataTips:"6月28日， 荣获工信部颁发2021（第二届）中国充电桩创新峰会中国充电桩最佳运营商奖项。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'3月',
                                dataTipsData:[
                                    {dataTips:"2021年3月9日，吉利帝豪ev300发布媒体品鉴会于 新能源4S店举办。"},
                                    
                                ]
                            },
                        ]
                    },
                    {
                        dataYear:'2020',
                        dataDetails:[
                            { 
                                dataMonth:'12月',
                                dataTipsData:[
                                    {dataTips:"2020年12月4日， 集团董事长庞雷参加第三届中国新能源汽车消费论坛，荣获“E时代领军者杰出贡献奖”。"}
                                ]
                            },                          
                            { 
                                dataMonth:'11月',
                                dataTipsData:[
                                    {dataTips:"2020年11月下旬， 受邀参加第七届北京国际充电站（桩）技术设备展览会，荣获“金桩奖”。"},
                                  
                                ]
                            },
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"2020年10月下旬， 受邀参加上海国际工业博览会，丰富的展品吸引了大批国内外专业观众驻足观摩，洽谈业务。"},
                                    {dataTips:"2020年10月初， 受邀出席顺义“新产业、新动能、新经济”投资峰会，将与中关村顺义园展开战略合作，共同构建顺义新能源智能汽车生态示范区。"},
                                ]
                            },
                            { 
                                dataMonth:'7月',
                                dataTipsData:[
                                    {dataTips:"2020年7月27日， 受邀参加“充电桩+与共享”2016中国充电桩创新峰会，荣获2020中国充电桩十大品牌。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'4月',
                                dataTipsData:[
                                    {dataTips:"2020年4月21日， 新能源4S店正式开业，标志着  旗下产业链形成了从前期汽车销售到后期充电服务的完整闭环。"},
                                    {dataTips:"2020年4月29日， 受邀参加中外知名企业投资顺义行发布会并同顺义区政策签约，成为首批入驻新园区的合作企业。"},
                                    {dataTips:"2020年4月8日， 新能源汽车销售有限公司作为北京地区总代理受邀参加吉利帝豪EV北京上市发布会。依托 新能源为平台，帝豪EV上市首月订单即突破千辆，成为销售黑马。"},
                                    
                                ]
                            },
                        ]
                    },
                    {
                        dataYear:'2019',
                        dataDetails:[
                            { 
                                dataMonth:'1月',
                                dataTipsData:[
                                    {dataTips:"2019年 将以北京、上海、西安三个城市为中心，带动京津冀、长三角、西部地区以及其他城市的充电设施建设，预计在全国建设710个超级充电站，建成28800根充电桩，投资规模达35 5亿。"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2018',
                        dataDetails:[
                            { 
                                dataMonth:'12月',
                                dataTipsData:[
                                    {dataTips:" 在国贸大饭店正式发布了2018全球战略。计划在2018-2019两年时间里，投资112 5个亿，进行超级充电站和目的地充电站的全球布局。其中，在中国本土市场，推出了“3+3”战略。"},
                                    {dataTips:" 技作为北京市首个PPP模式推行充电基础设施的建设运营方，全力推进首都新能源汽车的推广普及，集约利用土地缓解停车难题，大力开发新能源充电+立体停车设施的投资、建设和运营。"},
                                    {dataTips:"中国网财经12月31日讯  做市说明会29日在北京举行，说明会后公司董事长庞雷接受中国网财经记者采访。他介绍，公司移动充电车目前在上海、北京都有投放。"},
                                    {dataTips:"2月29日， 今日在北京召开做市说明会，并宣布计划在2018-2019两年时间里，投资112 5亿元进行超级充电站和目的地充电站的全球布局。"},
                                ]
                            },                          
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"2018年10月20日，在北京市石景山区，举行了首个光伏超级充电站的启动开工仪式。该项目总投资1500万元，建设占地约500平方米，通过立体停车设计建成后可以供约30个停车充电位。"},
                                ]
                            },    
                           
                        ]
                    },
                    {
                        dataYear:'2017',
                        dataDetails:[
                            { 
                                dataMonth:'9月',
                                dataTipsData:[
                                    {dataTips:"新三板(“全国中小企业股份转让系统”)迎来了第一家充电桩企业—— 科技有限公司。“新三板”被誉为“中国的纳斯达克”,是科技创新型企业的上市孵化器以及股权转让和投融资平台。"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2016',
                        dataDetails:[
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:" 充电桩入驻上海第一家五星级酒店（上海世茂皇家艾美酒店），使之成为上海首家拥有电动汽车充电区域的五星级酒店"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2015',
                        dataDetails:[
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:" 参加德国慕尼黑Ecar Tec展会，倡导电动汽车的发展"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                ]
            }
        },
        methods:{
            tabsClick(e){
                console.log(e)
                this.tabsIndex = e
                console.log( this.tabsIndex)
            },
        },
        created(){

        }
    }
</script>

<style scoped>
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.tabs1Title{
    text-align: center;
    font-size: 0.45rem;
    font-weight: 600;
    padding-top: 0.4rem;
}
.tabs1{
    font-size: 0.35rem;
    padding: 0.5rem 5%;
    /* line-height: 2rem; */
}
.tabsActive{
    color: #18D1BB !important;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.mob-line{
    width: 100%;
    height: 0.08rem;
    background-color: #18D1BB;
    /* margin: 0.2rem 0; */
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.line999{
    width: 100%;
    height: 6px;
    background-color: #eee;
}
.commonFather{
    background-color: #fff;
}
.tabsClass{
   
    color: #333;
    font-size: 0.38rem;
    margin-right: 15px;
}
.tabsFather{
    display: flex;
    align-items: center;
    padding-left: 15px;
    height: 44px;
    line-height: 44px;
}
</style>